export class Vessel {
    public imoNumber = null;
    public mmsi = null;
}
